import { MixpanelEventName, useAnalytics } from '@/app/utils/useAnalytics';
import cx from 'classnames';
import Link from 'next/link';

import styles from './NavDropdownSubItem.module.scss';

interface NavDropdownSubItemProps {
  id?: string;
  label: React.ReactNode;
  to: string;
  testid?: string;
  trackEventName?: MixpanelEventName;
  isActiveLink: boolean;
  onNavItemClick?: () => void;
  setOpen: (open: boolean) => void;
}

export const NavDropdownSubItem = ({
  id,
  label,
  to,
  testid,
  trackEventName,
  onNavItemClick,
  setOpen,
  isActiveLink,
}: NavDropdownSubItemProps) => {
  const track = useAnalytics();
  return (
    <Link prefetch={false} href={to} as={to} passHref>
      <a
        className={cx(styles.navDropdownSubItem, isActiveLink && styles.activeLink)}
        data-testid={testid}
        id={`${id}-${label}`}
        tabIndex={0}
        onClick={() => {
          trackEventName && track(trackEventName, {});
          setOpen(false);
          onNavItemClick?.();
        }}
        role="menuitem"
        onKeyDown={e => {
          if (e.code === 'Enter' || e.code === 'Space') {
            trackEventName && track(trackEventName, {});
            setOpen(false);
            onNavItemClick?.();
          }
        }}
      >
        {label}
      </a>
    </Link>
  );
};
